import React from 'react';
import styles from './dropdown.module.scss';

type Props = {
  options: { text: string; value: number | string }[];
  defaultValue?: number | string;
  value?: number | string;
  onChange?: (value: string) => void;
  ariaLabel: string;
  id: string;
  customClass?: string;
};

export default function Dropdown({
  onChange,
  options,
  defaultValue,
  value,
  ariaLabel,
  id,
  customClass,
}: Props) {
  function changeHandler(event: React.ChangeEvent<HTMLSelectElement>) {
    if (onChange) {
      onChange(event.target.value);
    }
  }

  return (
    <div
      className={`${styles[`dropdown-wrapper`]} dropdown-wrapper ${options.length === 1 && styles[`single-value`]} ${customClass || ``}`}
    >
      <select
        id={id}
        className={`${styles.dropdown} `}
        defaultValue={defaultValue}
        value={value}
        aria-label={ariaLabel}
        onChange={changeHandler}
      >
        {options.map((option) => (
          <option value={option.value} label={option.text} key={option.value}>
            {option.text}
          </option>
        ))}
      </select>
    </div>
  );
}
